import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { news } from "@/mocks/news";
import { topics } from "@/mocks/topics";
import { hotKeywords } from "@/mocks/site";
import type { NewsItem } from "@/types/content";

const allNews = news as NewsItem[];

const tabs = [
  { key: "all", label: "全部" },
  { key: "live", label: "实时跟进" },
  { key: "evening", label: "晚间热搜" },
  { key: "fresh", label: "刚刚发生" },
];

export default function LiveFeed() {
  const [active, setActive] = useState("all");

  const filtered = useMemo(() => {
    if (active === "live") return allNews.filter((item) => item.isLive);
    if (active === "evening") return allNews.filter((item) => item.isEvening);
    if (active === "fresh") return allNews.filter((item) => item.isFresh);
    return allNews;
  }, [active]);

  const list = filtered.slice(0, 6);
  const brief = allNews.slice(0, 6);

  return (
    <section id="live" className="w-full scroll-mt-20 bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="LIVE FEED"
          title="实时爆料流"
          desc="按发布时间滚动更新，今天最新的讨论、路透、官宣与热议都集中在这里，刷新即可看到新内容。"
        />

        <div className="mt-7 flex flex-wrap items-center gap-3">
          <div className="inline-flex items-center gap-1 rounded-full border border-background-300/70 bg-background-100 p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={`rounded-full px-4 py-1.5 text-sm transition-colors whitespace-nowrap cursor-pointer ${
                  active === tab.key
                    ? "bg-primary-500 text-background-50 font-medium"
                    : "text-foreground-700 hover:text-primary-600"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <span className="text-xs text-foreground-500">
            共 {filtered.length} 条符合条件的内容
          </span>
        </div>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          <div className="lg:col-span-2 space-y-4">
            {list.length > 0 ? (
              list.map((item) => <NewsCard key={item.id} item={item} variant="wide" />)
            ) : (
              <div className="rounded-lg border border-dashed border-background-400/70 bg-background-100 py-16 text-center">
                <p className="text-sm text-foreground-600">该分类暂时没有新的爆料，换个标签看看吧。</p>
              </div>
            )}

            <div className="pt-2">
              <Link
                to="/topics"
                className="inline-flex items-center gap-2 rounded-md border border-background-400/70 bg-background-100 px-5 py-3 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览全部栏目与专题
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </Link>
            </div>
          </div>

          <aside className="space-y-6">
            <div className="rounded-lg border border-background-300/60 bg-background-100 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">栏目速览</h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {topics.map((topic) => (
                  <Link
                    key={topic.slug}
                    to="/topics"
                    className="inline-flex items-center gap-1.5 rounded-full border border-background-300/80 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {topic.name}
                    <span className="text-foreground-400">{topic.count}</span>
                  </Link>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-300/60 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="w-5 h-5 flex items-center justify-center text-accent-600">
                  <i className="ri-price-tag-3-line" aria-hidden="true"></i>
                </span>
                热词榜
              </h3>
              <ul className="mt-4 space-y-2.5">
                {hotKeywords.slice(0, 8).map((word, index) => (
                  <li key={word} className="flex items-center gap-3">
                    <span
                      className={`w-5 h-5 shrink-0 flex items-center justify-center rounded text-[11px] font-bold ${
                        index < 3
                          ? "bg-accent-100 text-accent-900"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <Link
                      to="/topics"
                      className="truncate text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      #{word}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-300/60 bg-background-100 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">最新快讯</h3>
              <div className="mt-1">
                {brief.map((item) => (
                  <NewsCard key={item.id} item={item} variant="compact" />
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}